import { AddressCardStack } from './address-card-stack';
import { Type } from '@angular/core';
import { CardBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/card-background.component';
import { PrintCardContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/shared/print-card-content.component';
import { GenericAddressCardStackBackgroundComponent } from '../../../../../modules/print-cards/components/cards/backgrounds/address-cards-1x3/generic-address-card-stack-background/generic-address-card-stack-background.component';
import { GenericAddressCardStackContentComponent } from '../../../../../modules/print-cards/components/cards/card-content/address-cards-1x3/generic-address-card-stack-content/generic-address-card-stack-content.component';
import type { CardData } from '../../../../print-cards/card-data';

export class GenericAddressCardStack extends AddressCardStack {
  getCardBackgroundComponent(cardData: CardData): Type<CardBackgroundComponent> {
    return GenericAddressCardStackBackgroundComponent;
  }

  getCardContentComponent(cardData: CardData): Type<PrintCardContentComponent> {
    return GenericAddressCardStackContentComponent;
  }
}
